export default class RelogioPonto {
    constructor() {
        this.id = null;
        this.numeroSerie = null;
        this.fabricante = '';
        this.autorizacao = null;
        this.dataCadastro = null;
        this.dataAutorizacao = null;
        this.localInstalacao = null;
        this.modelo = '';
        this.portaria = '';
        this.integracaoLeitorFacial = false;
        this.numeroSerieLeitorFacial = null;
        this.tipoServico = '';
        this.proximoNSR = null;
        this.idCloud = null;
    }    
}